<template>
<div class="container">
  <Card>
    <Breadcrumb>
        <BreadcrumbItem >首页</BreadcrumbItem>
        <BreadcrumbItem >我的订单</BreadcrumbItem>
        <BreadcrumbItem>批量退票</BreadcrumbItem>
    </Breadcrumb>
    <div class="refund-table">
        <Table border ref="selection" :columns="columns" :data="data1"></Table>
        <div class="btn-group">
          <div>
            <Button type="primary" style="width:80px" @click="handleRefund">退票</Button>
          </div>
          <div>
            <Button type="primary" style="margin-left:5px;width:80px" @click="goback">返回</Button>
          </div>
        </div>
    </div>
  </Card>
</div>
</template>

<script>
import { httpAction } from '@/api/manage'
export default {
  data () {
    return {
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '门票',
          key: 'displayName'
        },
        {
          title: '游玩日期',
          key: 'playDate'
        },
        {
          title: '验票时段',
          key: 'playPeriodName'
        },
        {
          title: '游览人',
          key: 'name'
        },
        {
          title: '证件号码',
          key: 'cerNo'
        },
        {
          title: '门票状态',
          key: 'ticketStatusName'
        }
      ],
      data1: []
      // url: {
      //   list: '/openapi/indi/orderDetail',
      //   refund: '/yhy/openapi/web/individual/multiRefundTicket'
      // }
    }
  },
  mounted () {
    const param = { id: this.$route.query.orderId }
    this.getRefundList(param)
  },
  methods: {
    async getRefundList (param) {
      console.log('gdfkjhnfsfhgsadklfjhafdasdf')
      const res = await httpAction(this.common.getOrderDetailUrl(), 'post', param)
      const data = res.data.itemList;
      this.data1 = []
      for (var i = 0; i < data.length; i++) {
        if (data[i].canRefund === '0' && data[i].ticketStatus === '2') {
          this.data1.push(data[i])
        }
      }
      // console.log(this.data1)
      // 处理退票不可点选modby jushuai updated 20200718 begin
      // for (var i = 0; i < this.data1.length; i++) {
      //   if (this.data1[i].canRefund !== '0') {
      //     this.data1[i]._disabled = true
      //   }
      // }
      // } //处理退票不可点选modby jushuai updated 20200718 end
    },
    handleRefund () {
      this.$Modal.confirm({
        title: '是否确认退票',
        onOk: async () => {
          const orderItemIdListArr = []
          for (const item of this.$refs.selection.getSelection()) {
            orderItemIdListArr.push(item.id)
          }
          if (orderItemIdListArr.length === 0) {
            this.$Message.error('请选择门票')
          } else {
            const param = { orderId: this.$route.query.orderId, orderItemIdList: orderItemIdListArr }
            const res = await httpAction(this.common.getRefundUrl(), 'post', param)
            if (res.status === '0') {
              this.$Message.success('正在退票,请耐心等待')
              setTimeout(() => {
                const param = { orderId: this.$route.query.orderId }
                this.getRefundList(param)
              }, 2000)
            } else {
              this.$Message.error(res.errorMessage)
            }
          }
        },
        onCancel: () => {
        }
      })
      // console.log(this.$refs.selection.getSelection())
    },
    goback () {
      this.$router.push({ path: '/order' })
    }
    // handleSelectAll (status) {
    //   this.$refs.selection.selectAll(status)
    // }
    // test (val) {
    //   const params = { id: val }
    //   const routeData = this.$router.resolve({
    //     name: 'User_Info',
    //     query: params
    //   })
    //   window.open(routeData.href, '_blank')
    // }
  }
}
</script>

<style scoped>
.container{
  margin:20px 0
}
.refund-table{
  margin-top:30px;
}
.btn-group{
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

</style>
